// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__32jX9","active":"NavigationItem_active__12lBM"};